import React from 'react'
import { FaRegCalendarTimes } from 'react-icons/fa'

function NoAppointmentsCard() {
  return (
    <div className="w-full max-w-md mx-auto mt-10 bg-white  rounded-2xl p-6 flex flex-col items-center text-center">
    <FaRegCalendarTimes className="text-gray-400 w-16 h-16 mb-4" />
    <h2 className="text-xl font-semibold text-gray-700">
      No Appointments
    </h2>
    <p className="text-gray-500 mt-2">
      Nothing scheduled at the moment.
    </p>
  </div>
  )
}

export default NoAppointmentsCard
